import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';
import { GlobalErrorComponent } from '@frontend/shared';

@Component({
  selector: 'app-error',
  standalone: true,
  imports: [TranslatePipe, GlobalErrorComponent],
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorComponent {}
